(() => {
  /* ciara-set-buy:20261012d-sold-out-label — option sheet Sold out (locale) + sticky parity */
  const STRINGS = () => {
    var _a;
    const s = ((_a = window.themeVariables) == null ? void 0 : _a.strings) || {};
    return {
      heading: s.setBuyHeading || "人気カスタム商品",
      relatedHeading: s.setBuyRelatedHeading || "おすすめ商品",
      addToCart: s.productFormAddToCart || "カートに追加",
      addShort: s.setBuyAdd || "追加",
      soldOut: s.productFormSoldOut || "売り切れ",
      unavailable: s.productFormUnavailable || "選択不可",
      selectVariant: s.setBuySelectVariant || "オプションを選択",
      added: s.setBuyAdded || "カートに追加しました",
      close: s.accessibilityClose || "閉じる"
    };
  };

  const CHEVRON_SVG = `<svg focusable="false" width="12" height="8" class="icon icon--chevron" viewBox="0 0 12 8" aria-hidden="true"><path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="1.5"></path></svg>`;
  const CLOSE_SVG = `<svg focusable="false" width="14" height="14" class="icon icon--close" viewBox="0 0 14 14" aria-hidden="true"><path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="2" fill="none"></path></svg>`;

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function formatMoney(cents) {
    if (typeof window.Shopify !== "undefined" && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, window.themeVariables.settings.moneyFormat);
    }
    const amount = (Number(cents) / 100).toFixed(0);
    return `¥${Number(amount).toLocaleString("ja-JP")}`;
  }

  function imageUrl(productOrImage, width = 140) {
    const img = productOrImage && (productOrImage.featured_image || productOrImage.src || productOrImage.url)
      ? (productOrImage.featured_image || productOrImage)
      : (productOrImage && productOrImage.images && productOrImage.images[0]) || null;
    if (!img) return null;
    const src = typeof img === "string" ? img : img.src || img.url;
    if (!src) return null;
    if (src.includes("{width}")) {
      return src.replace("{width}", String(width));
    }
    return src.replace(/(\.\w+)(\?|$)/, `_${width}x$1$2`);
  }

  function recommendationsFetchUrl(productId, limit, intent = "complementary") {
    const root = window.themeVariables.routes.rootUrlWithoutSlash || "";
    const safeIntent = intent === "related" ? "related" : "complementary";
    return `${root}/recommendations/products.json?product_id=${productId}&limit=${limit}&intent=${safeIntent}`;
  }

  async function fetchRecommendations(productId, limit, intent = "complementary") {
    const response = await fetch(recommendationsFetchUrl(productId, limit, intent));
    if (!response.ok) return [];
    const json = await response.json();
    return Array.isArray(json.products) ? json.products : [];
  }

  /** @deprecated Use fetchRecommendations — kept for callers expecting complementary. */
  async function fetchComplementary(productId, limit) {
    return fetchRecommendations(productId, limit, "complementary");
  }

  /**
   * When under-ATC complementary falls back to related, hide the bottom
   * おすすめ商品 rail so related is not shown twice on the same PDP.
   */
  function hidePdpBottomRelatedRails() {
    document.documentElement.setAttribute("data-set-buy-related-under-atc", "1");
    document.querySelectorAll('[data-product-related-rail="related"]').forEach((wrap) => {
      wrap.remove();
    });
    document.querySelectorAll(".product-content__featured-products--set-buy").forEach((wrap) => {
      const rail = wrap.querySelector('set-buy-rail[intent="related"], set-buy-rail');
      if (rail) wrap.remove();
    });
  }

  function announceUnderAtcResolved(usedRelatedFallback) {
    document.documentElement.dispatchEvent(new CustomEvent("set-buy:under-atc-resolved", {
      bubbles: true,
      detail: { usedRelatedFallback: !!usedRelatedFallback }
    }));
  }

  function filterExcludedProducts(products, excludeRaw) {
    if (!excludeRaw || !products.length) return products;
    const exclude = new Set(excludeRaw.split(",").map((id) => String(id.trim())).filter(Boolean));
    return products.filter((p) => !exclude.has(String(p.id)));
  }

  function collectCartPageSectionIds() {
    var _a;
    if (((_a = window.themeVariables) == null ? void 0 : _a.settings) == null || window.themeVariables.settings.pageType !== "cart") {
      return [];
    }
    const ids = [];
    const main = document.getElementById("shopify-section-main")
      || document.querySelector('form[action*="/cart"]') && document.querySelector('form[action*="/cart"]').closest(".shopify-section");
    const recs = document.querySelector(".shopify-section--cart-recommendations")
      || document.getElementById("shopify-section-cart-recommendations");
    [main, recs].forEach((el) => {
      if (!el || !el.id || !el.id.startsWith("shopify-section-")) return;
      const id = el.id.slice("shopify-section-".length);
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function replaceShopifySection(sectionId, html) {
    if (!sectionId || !html) return false;
    const current = document.getElementById(`shopify-section-${sectionId}`);
    if (!current) return false;
    const wrap = document.createElement("div");
    wrap.innerHTML = html.trim();
    const next = wrap.querySelector(`#shopify-section-${sectionId}`) || wrap.firstElementChild;
    if (!next) return false;
    current.replaceWith(next);
    return true;
  }

  /**
   * Cart page has no theme listener for line-item HTML on cart:refresh
   * (that event only drives mini-cart + count). Re-render main +
   * cart-recommendations from Section Rendering / Cart API sections.
   */
  async function refreshCartPageSections(sectionsHtml) {
    const ids = collectCartPageSectionIds();
    if (!ids.length) return;

    const pending = ids.filter((id) => !(sectionsHtml && sectionsHtml[id]));
    if (pending.length) {
      await Promise.all(pending.map(async (id) => {
        try {
          const response = await fetch(`${window.themeVariables.routes.cartUrl}?section_id=${encodeURIComponent(id)}`);
          if (!response.ok) return;
          const html = await response.text();
          sectionsHtml = sectionsHtml || {};
          sectionsHtml[id] = html;
        } catch (_err) {
          /* ignore */
        }
      }));
    }

    ids.forEach((id) => {
      if (sectionsHtml && sectionsHtml[id]) {
        replaceShopifySection(id, sectionsHtml[id]);
      }
    });
  }

  async function addVariantToCart(variantId, quantity = 1, options = {}) {
    var _a, _b;
    const extraSections = Array.isArray(options.sections) ? options.sections : [];
    const sectionIds = ["mini-cart"].concat(extraSections).filter((id, index, arr) => id && arr.indexOf(id) === index);
    const body = new FormData();
    body.append("id", String(variantId));
    body.append("quantity", String(quantity));
    body.append("sections", sectionIds.join(","));
    const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest" },
      body
    });
    const responseJson = await response.json();
    if (response.ok) {
      const lineItem = responseJson.hasOwnProperty("items") ? responseJson.items[0] : responseJson;
      document.documentElement.dispatchEvent(new CustomEvent("variant:added", {
        bubbles: true,
        detail: { variant: lineItem }
      }));
      try {
        const cartResponse = await fetch(`${window.themeVariables.routes.cartUrl}.js`);
        const cartContent = await cartResponse.json();
        cartContent.sections = responseJson.sections;
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
          bubbles: true,
          detail: { cart: cartContent }
        }));
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: { cart: cartContent, openMiniCart: false }
        }));
        if (options.refreshCartPage) {
          await refreshCartPageSections(responseJson.sections || {});
        }
      } catch (_err) {
        /* ignore cart refresh failures */
      }
      /*
        Cart page already refreshes line items + related rail after set-buy ATC.
        Skip pinned CartNotification toast (「カートに追加する / カートを見る」).
        PDP / toast / other pages keep the notification.
      */
      const onCartPage = ((_b = (_a = window.themeVariables) == null ? void 0 : _a.settings) == null ? void 0 : _b.pageType) === "cart";
      if (!options.suppressNotification && !onCartPage) {
        document.documentElement.dispatchEvent(new CustomEvent("cart-notification:show", {
          bubbles: true,
          cancelable: true,
          detail: {
            status: "success",
            error: "",
            product_id: lineItem && lineItem.product_id
          }
        }));
      }
    }
    return { ok: response.ok, json: responseJson };
  }

  function getModal() {
    return document.getElementById("SetBuyModal");
  }

  /**
   * Singleton option picker — reuses Focal sticky-ATC <combo-box> UI (white
   * bottom sheet on mobile styles). Lazy-created on first open. Writes back to
   * the card/modal hidden <select> + change so _syncInlineCard / modal sync stay.
   */
  var SetBuyOptionSheet = {
    _el: null,
    _select: null,
    _trigger: null,
    _bound: false,
    _suppressMirror: false,

    ensure() {
      if (this._el) return this._el;
      const strings = STRINGS();
      /* Prefer real combo-box CE (same as product-sticky-form). Fallback: div. */
      const tag = customElements.get("combo-box") ? "combo-box" : "div";
      const el = document.createElement(tag);
      el.id = "SetBuyOptionSheet";
      el.className = "combo-box set-buy-option-combo";
      el.setAttribute("initial-focus-selector", "[aria-selected='true']");
      el.innerHTML = `
        <span class="combo-box__overlay"></span>
        <header class="combo-box__header">
          <p class="combo-box__title heading h6" id="SetBuyOptionSheetTitle" data-set-buy-option-sheet-title></p>
          <button type="button" class="combo-box__close-button tap-area" data-action="close" title="${escapeHtml(strings.close)}" aria-label="${escapeHtml(strings.close)}">
            ${CLOSE_SVG}
          </button>
        </header>
        <div class="combo-box__option-list" role="listbox" aria-labelledby="SetBuyOptionSheetTitle" data-set-buy-option-sheet-list></div>
        <select class="visually-hidden" data-set-buy-option-sheet-select tabindex="-1" aria-hidden="true"></select>
      `;
      document.body.appendChild(el);
      this._el = el;
      this._onMirrorChange = this._onMirrorChange.bind(this);
      this._onOpenableClose = this._onOpenableClose.bind(this);
      this._onDocKeyDown = this._onDocKeyDown.bind(this);
      el.addEventListener("change", this._onMirrorChange);
      el.addEventListener("openable-element:close", this._onOpenableClose);
      /* Fallback click path if combo-box CE is unavailable. */
      if (tag === "div") {
        el.addEventListener("click", (event) => {
          if (event.target.closest("[data-action='close'], .combo-box__overlay")) {
            this.close();
            return;
          }
          const option = event.target.closest('[role="option"]');
          if (!option || option.classList.contains("is-disabled")) return;
          this._applyValue(option.getAttribute("value") || option.value);
        });
      }
      this._bound = true;
      return el;
    },

    isOpen() {
      const el = this._el;
      if (!el) return false;
      return el.hasAttribute("open") || el.classList.contains("is-open");
    },

    /**
     * @param {{ select: HTMLSelectElement, trigger: HTMLElement, title?: string }} opts
     */
    open(opts) {
      if (!opts || !opts.select || !opts.trigger) return;
      const el = this.ensure();
      if (this.isOpen()) this.close();
      this._select = opts.select;
      this._trigger = opts.trigger;
      const title = opts.title
        || opts.select.getAttribute("aria-label")
        || STRINGS().selectVariant;
      const titleEl = el.querySelector("[data-set-buy-option-sheet-title]");
      if (titleEl) titleEl.textContent = title;
      this._renderOptions();
      if (this._trigger) {
        this._trigger.setAttribute("aria-expanded", "true");
        this._trigger.setAttribute("aria-controls", el.id);
      }
      document.addEventListener("keydown", this._onDocKeyDown, true);
      if (typeof el.open === "boolean" || "open" in el) {
        el.open = true;
      } else {
        el.setAttribute("open", "");
        el.classList.add("is-open");
        document.documentElement.classList.add("lock-mobile");
      }
    },

    close() {
      const el = this._el;
      if (!el) return;
      document.removeEventListener("keydown", this._onDocKeyDown, true);
      if (typeof el.open === "boolean" || "open" in el) {
        el.open = false;
      } else {
        el.removeAttribute("open");
        el.classList.remove("is-open");
        document.documentElement.classList.remove("lock-mobile");
        this._onOpenableClose();
      }
    },

    _renderOptions() {
      const el = this._el;
      const source = this._select;
      if (!el || !source) return;
      const list = el.querySelector("[data-set-buy-option-sheet-list]");
      const mirror = el.querySelector("[data-set-buy-option-sheet-select]");
      if (!list || !mirror) return;
      const current = source.value;
      /* Text-only rows (Size/機種). Color-chip-in-list is sticky-ATC Color sheet scope elsewhere. */
      const soldOutLabel = escapeHtml(STRINGS().soldOut);
      list.innerHTML = Array.from(source.options).map((opt) => {
        const disabled = opt.disabled;
        const selected = String(opt.value) === String(current);
        return `
          <button
            type="button"
            role="option"
            class="combo-box__option-item${disabled ? " is-disabled" : ""}"
            value="${escapeHtml(opt.value)}"
            aria-selected="${selected ? "true" : "false"}"
            ${disabled ? 'disabled aria-disabled="true"' : ""}
          >${escapeHtml(opt.textContent)}<span class="combo-box__option-sold-out">${soldOutLabel}</span></button>
        `;
      }).join("");
      this._suppressMirror = true;
      mirror.innerHTML = Array.from(source.options).map((opt) => {
        const selectedAttr = String(opt.value) === String(current) ? " selected" : "";
        const disabledAttr = opt.disabled ? " disabled" : "";
        return `<option value="${escapeHtml(opt.value)}"${selectedAttr}${disabledAttr}>${escapeHtml(opt.textContent)}</option>`;
      }).join("");
      mirror.value = current;
      this._suppressMirror = false;
      /* ComboBox caches options in connectedCallback — refresh after rebuild. */
      if (el.options) {
        el.options = Array.from(list.querySelectorAll('[role="option"]'));
      }
      if (typeof el.selectedValue !== "undefined") {
        el.selectedValue = current;
      }
    },

    _onMirrorChange(event) {
      if (this._suppressMirror) return;
      const mirror = this._el && this._el.querySelector("[data-set-buy-option-sheet-select]");
      if (!mirror || event.target !== mirror) return;
      this._applyValue(mirror.value);
    },

    _applyValue(value) {
      const select = this._select;
      const trigger = this._trigger;
      if (!select) {
        this.close();
        return;
      }
      const match = Array.from(select.options).find((opt) => String(opt.value) === String(value) && !opt.disabled);
      if (!match) {
        this.close();
        return;
      }
      select.value = value;
      Array.from(select.options).forEach((opt) => {
        opt.selected = String(opt.value) === String(value);
      });
      syncOptionTriggerLabel(trigger, value, select);
      select.dispatchEvent(new Event("change", { bubbles: true }));
      /* ComboBox already closes itself on option click; ensure trigger state. */
      if (this._trigger) this._trigger.setAttribute("aria-expanded", "false");
    },

    _onOpenableClose() {
      document.removeEventListener("keydown", this._onDocKeyDown, true);
      if (this._trigger) {
        this._trigger.setAttribute("aria-expanded", "false");
      }
      this._select = null;
      this._trigger = null;
      const list = this._el && this._el.querySelector("[data-set-buy-option-sheet-list]");
      if (list) list.innerHTML = "";
    },

    _onDocKeyDown(event) {
      if (!this.isOpen()) return;
      if (event.key === "Escape") {
        /* Close sheet before set-buy modal (capture). ComboBox trap also handles. */
        event.preventDefault();
        event.stopPropagation();
        this.close();
      }
    }
  };

  function syncOptionTriggerLabel(trigger, value, select) {
    if (!trigger) return;
    const label = trigger.querySelector("[data-set-buy-option-trigger-label], [data-set-buy-option-label]");
    if (label) label.textContent = value;
    const swatch = trigger.querySelector("[data-set-buy-swatch]");
    if (swatch) {
      swatch.setAttribute("style", resolveThemeSwatchStyle(value));
      swatch.classList.toggle("select__color-swatch--white", String(value).toLowerCase() === "white");
    }
    const name = trigger.getAttribute("data-option-name")
      || (select && select.getAttribute("aria-label"))
      || "";
    if (name) trigger.setAttribute("aria-label", `${name}: ${value}`);
  }

  /** Open sticky-ATC combo-box from a trigger near its paired hidden select. */
  function openOptionSheetFromTrigger(trigger) {
    if (!trigger) return false;
    const wrap = trigger.closest(".set-buy-card__select-wrap, .select-wrapper, [data-set-buy-option-wrap]");
    const select = (wrap && wrap.querySelector("select[data-set-buy-card-select], select[data-set-buy-option]"))
      || null;
    if (!select) return false;
    const title = select.getAttribute("aria-label")
      || trigger.getAttribute("data-option-name")
      || STRINGS().selectVariant;
    SetBuyOptionSheet.open({ select, trigger, title });
    return true;
  }

  function normalizeOptions(product) {
    const raw = product.options || [];
    if (!raw.length) return [];
    if (typeof raw[0] === "string") {
      return raw.map((name, index) => {
        const values = Array.from(new Set((product.variants || []).map((v) => v[`option${index + 1}`]).filter(Boolean)));
        return { name, position: index + 1, values };
      });
    }
    return raw.map((opt, index) => ({
      name: opt.name || `Option ${index + 1}`,
      position: opt.position || index + 1,
      values: opt.values || []
    })).filter((opt) => opt.values.length && !(opt.values.length === 1 && opt.values[0] === "Default Title"));
  }

  function optionLabelList(key) {
    var _a, _b;
    const list = (_b = (_a = window.themeVariables) == null ? void 0 : _a.settings) == null ? void 0 : _b[key];
    return Array.isArray(list) ? list : [];
  }

  function optionNameMatches(name, labelList, regex) {
    const n = String(name || "").trim().toLowerCase();
    if (!n) return false;
    if (regex.test(n)) return true;
    return (labelList || []).some((label) => {
      const l = String(label || "").trim().toLowerCase();
      return Boolean(l) && (n === l || n.includes(l));
    });
  }

  function isColorOption(name) {
    return optionNameMatches(name, optionLabelList("colorOptionNames"), /color|colour|カラー|色/i);
  }

  function isSizeOption(name) {
    /* Include 機種 — Ciara phone-model option often uses this label. */
    return optionNameMatches(name, optionLabelList("sizeOptionNames"), /size|サイズ|機種|model|device/i);
  }

  function parsePreferredOptions(raw) {
    if (!raw) return [];
    try {
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed
        .map((item) => ({
          name: item && item.name != null ? String(item.name) : "",
          value: item && item.value != null ? String(item.value) : ""
        }))
        .filter((item) => item.value);
    } catch (_err) {
      return [];
    }
  }

  function optionHasValue(option, value) {
    return (option.values || []).some((v) => String(v) === String(value));
  }

  function optionNamesFromProduct(product) {
    if (!product) return [];
    const raw = product.options || [];
    if (!raw.length) return [];
    if (typeof raw[0] === "string") return raw.map((name) => String(name));
    return raw.map((opt, index) => String((opt && opt.name) || `Option ${index + 1}`));
  }

  function preferredOptionsFromVariant(variant, optionNames) {
    if (!variant) return [];
    const names = optionNames || [];
    const values = Array.isArray(variant.options) && variant.options.length
      ? variant.options
      : [variant.option1, variant.option2, variant.option3].filter((v) => v != null && String(v) !== "");
    return values
      .map((value, index) => ({
        name: names[index] || "",
        value: String(value)
      }))
      .filter((item) => item.value);
  }

  /** product-variants CE for this PDP product (ProductLoader payload). */
  function findProductVariantsEl(productId) {
    const nodes = document.querySelectorAll("product-variants");
    for (let i = 0; i < nodes.length; i += 1) {
      const el = nodes[i];
      if (el.product && productId != null && String(el.product.id) === String(productId)) {
        return el;
      }
    }
    return nodes.length === 1 ? nodes[0] : null;
  }

  /**
   * Cart + PDP cards: prefer source size/機種 (and matching non-color option
   * values) when present + available; otherwise first available selection.
   * Cart source = line options; PDP source = selected product-form variant.
   */
  function cartInitialSelection(product, options, preferredOptions) {
    const fallback = firstAvailableSelection(product, options);
    const variants = product.variants || [];
    const prefs = preferredOptions || [];
    if (!options.length || !prefs.length) return fallback;

    const selected = fallback.slice();

    options.forEach((option, index) => {
      if (isColorOption(option.name)) return;

      let match = null;
      /* 1) Same option name + value exists on complementary product */
      for (let i = 0; i < prefs.length; i += 1) {
        const pref = prefs[i];
        if (
          String(pref.name).trim().toLowerCase() === String(option.name).trim().toLowerCase()
          && optionHasValue(option, pref.value)
        ) {
          match = pref.value;
          break;
        }
      }
      /* 2) Size/機種 option: any preferred value that appears in values */
      if (!match && isSizeOption(option.name)) {
        for (let i = 0; i < prefs.length; i += 1) {
          const pref = prefs[i];
          if (optionHasValue(option, pref.value)) {
            match = pref.value;
            break;
          }
        }
      }
      /* 3) Non-color fallback: preferred value listed on this option */
      if (!match) {
        for (let i = 0; i < prefs.length; i += 1) {
          const pref = prefs[i];
          if (optionHasValue(option, pref.value)) {
            match = pref.value;
            break;
          }
        }
      }
      if (match) selected[index] = match;
    });

    const direct = findVariant(variants, selected);
    if (direct && direct.available) return selected;

    /* Keep preferred non-color picks; pick best available variant by match score */
    const available = variants.filter((v) => v.available);
    let best = null;
    let bestScore = -1;
    available.forEach((variant) => {
      let score = 0;
      options.forEach((option, index) => {
        const val = variant[`option${index + 1}`];
        if (isColorOption(option.name)) return;
        if (prefs.some((pref) => String(pref.value) === String(val))) score += 2;
        if (String(val) === String(selected[index]) && String(selected[index]) !== String(fallback[index])) {
          score += 1;
        }
      });
      if (score > bestScore) {
        bestScore = score;
        best = variant;
      }
    });
    if (best && bestScore > 0) {
      return options.map((_, index) => best[`option${index + 1}`] || "");
    }
    return fallback;
  }

  /** Modal-only: raw option value as CSS color (unchanged for PDP/toast). */
  function swatchStyle(value) {
    const v = String(value || "").trim().toLowerCase();
    if (!v) return "";
    return `background-color: ${v}`;
  }

  /** Cart cards: Theme Editor color_swatch_config map (same source as PDP). */
  function resolveThemeSwatchStyle(value) {
    var _a, _b;
    const key = String(value || "").trim().toLowerCase();
    if (!key) return "";
    const map = ((_b = (_a = window.themeVariables) == null ? void 0 : _a.settings) == null ? void 0 : _b.colorSwatchConfig) || {};
    if (map[key]) return map[key];
    if (key.charAt(0) === "#") return `background-color: ${key}`;
    return "background-color: #e0e0e0";
  }

  function findVariant(variants, selectedOptions) {
    return (variants || []).find((variant) => {
      return selectedOptions.every((value, index) => {
        if (!value) return false;
        return String(variant[`option${index + 1}`] || "") === String(value);
      });
    }) || null;
  }

  function firstAvailableSelection(product, options) {
    const available = (product.variants || []).find((v) => v.available) || (product.variants || [])[0];
    if (!available) return options.map(() => "");
    return options.map((_, index) => available[`option${index + 1}`] || "");
  }

  function productHref(product) {
    if (product && product.url) return product.url;
    if (product && product.handle) {
      return `${window.themeVariables.routes.rootUrlWithoutSlash || ""}/products/${product.handle}`;
    }
    return "";
  }

  /** Whether any available variant matches other selections with this option value. */
  function isOptionValueAvailable(variants, optionIndex, value, selectedOptions) {
    return (variants || []).some((variant) => {
      if (!variant.available) return false;
      for (let i = 0; i < selectedOptions.length; i += 1) {
        const expected = i === optionIndex ? value : selectedOptions[i];
        if (!expected) continue;
        if (String(variant[`option${i + 1}`] || "") !== String(expected)) return false;
      }
      return true;
    });
  }

  var SetBuyModal = class extends HTMLElement {
    connectedCallback() {
      this._onKeyDown = this._onKeyDown.bind(this);
      this._onCloseClick = this._onCloseClick.bind(this);
      this.addEventListener("click", this._onCloseClick);
      this._lastFocus = null;
    }
    disconnectedCallback() {
      this.removeEventListener("click", this._onCloseClick);
      document.removeEventListener("keydown", this._onKeyDown);
    }
    _onCloseClick(event) {
      const optionTrigger = event.target.closest("[data-set-buy-option-trigger]");
      if (optionTrigger && this.contains(optionTrigger)) {
        event.preventDefault();
        openOptionSheetFromTrigger(optionTrigger);
        return;
      }
      if (event.target.closest("[data-set-buy-close]")) {
        event.preventDefault();
        if (SetBuyOptionSheet.isOpen()) SetBuyOptionSheet.close();
        this.close();
      }
    }
    _onKeyDown(event) {
      if (event.key === "Escape") {
        if (SetBuyOptionSheet.isOpen()) {
          SetBuyOptionSheet.close();
          return;
        }
        this.close();
      }
    }
    open(product) {
      this._product = product;
      this._render(product);
      this._lastFocus = document.activeElement;
      this.hidden = false;
      document.documentElement.classList.add("lock-set-buy-modal");
      document.addEventListener("keydown", this._onKeyDown);
      const dialog = this.querySelector("[data-set-buy-dialog]");
      requestAnimationFrame(() => {
        const focusTarget = this.querySelector("[data-set-buy-option-trigger]")
          || this.querySelector("[data-set-buy-add]")
          || dialog;
        focusTarget && focusTarget.focus();
      });
    }
    close() {
      if (SetBuyOptionSheet.isOpen()) SetBuyOptionSheet.close();
      this.hidden = true;
      document.documentElement.classList.remove("lock-set-buy-modal");
      document.removeEventListener("keydown", this._onKeyDown);
      if (this._lastFocus && typeof this._lastFocus.focus === "function") {
        this._lastFocus.focus();
      }
    }
    _render(product) {
      const strings = STRINGS();
      const body = this.querySelector("[data-set-buy-body]");
      if (!body) return;

      const variants = product.variants || [];
      const options = normalizeOptions(product);
      const availableVariants = variants.filter((v) => v.available);
      const selected = firstAvailableSelection(product, options);
      const initialVariant = findVariant(variants, selected) || availableVariants[0] || variants[0] || null;
      const img = imageUrl(initialVariant && initialVariant.featured_image ? initialVariant : product, 120);
      const price = formatMoney((initialVariant && initialVariant.price) || product.price);
      const title = escapeHtml(product.title || "");
      const productUrl = product.url || (product.handle ? `${(window.themeVariables.routes.rootUrlWithoutSlash || "")}/products/${product.handle}` : "");
      const productHref = productUrl ? escapeHtml(productUrl) : "";

      const optionsHtml = options.length ? `
        <div class="product-sticky-form__variants" data-set-buy-variants>
          ${options.map((option, index) => {
            const isColor = isColorOption(option.name);
            const current = selected[index] || option.values[0] || "";
            const faceSwatch = isColor
              ? `<span class="select__color-swatch${String(current).toLowerCase() === "white" ? " select__color-swatch--white" : ""}" data-set-buy-swatch style="${swatchStyle(current)}"></span>`
              : "";
            const collapseClass = options.length > 1
              ? (index === 0 ? " select--collapse-end" : index === options.length - 1 ? " select--collapse-start" : " select--collapse-start select--collapse-end")
              : "";
            return `
              <div class="select-wrapper" data-selector-type="dropdown" data-set-buy-option-wrap>
                <button
                  type="button"
                  class="select set-buy-modal__select-trigger${collapseClass}"
                  data-set-buy-option-trigger
                  data-option-name="${escapeHtml(option.name)}"
                  aria-expanded="false"
                  aria-haspopup="listbox"
                  aria-label="${escapeHtml(option.name)}: ${escapeHtml(current)}"
                >
                  <span class="select__selected-value">
                    ${faceSwatch}
                    <span data-set-buy-option-label>${escapeHtml(current)}</span>
                  </span>
                  ${CHEVRON_SVG}
                </button>
                <select class="visually-hidden set-buy-modal__native-select" data-set-buy-option="${index}" aria-label="${escapeHtml(option.name)}" tabindex="-1">
                  ${option.values.map((value) => {
                    const selectedAttr = String(value) === String(current) ? " selected" : "";
                    return `<option value="${escapeHtml(value)}"${selectedAttr}>${escapeHtml(value)}</option>`;
                  }).join("")}
                </select>
              </div>
            `;
          }).join("")}
        </div>
      ` : "";

      const canAddInitially = Boolean(initialVariant && initialVariant.available);

      body.innerHTML = `
        <div class="product-sticky-form set-buy-modal__sticky">
          <div class="product-sticky-form__inner">
            <div class="product-sticky-form__content-wrapper">
              <div class="product-sticky-form__image-wrapper">
                ${img ? (
                  productHref
                    ? `<a class="set-buy-modal__product-link" href="${productHref}"><img class="product-sticky-form__image" src="${img}" alt="${title}" width="60" height="60" loading="lazy" data-set-buy-image></a>`
                    : `<img class="product-sticky-form__image" src="${img}" alt="${title}" width="60" height="60" loading="lazy" data-set-buy-image>`
                ) : ""}
              </div>
              <div class="product-sticky-form__info">
                <div class="product-sticky-form__bottom-info">
                  ${productHref
                    ? `<a id="SetBuyModalTitle" class="product-sticky-form__title set-buy-modal__product-link" href="${productHref}">${title}</a>`
                    : `<span id="SetBuyModalTitle" class="product-sticky-form__title">${title}</span>`}
                  <span class="product-sticky-form__price" data-set-buy-price>${price}</span>
                </div>
              </div>
            </div>
            <div class="product-sticky-form__form">
              ${optionsHtml}
              <p class="set-buy-modal__status" data-set-buy-status role="status" aria-live="polite"></p>
              <div class="product-sticky-form__payment-container">
                <button type="button" class="product-form__add-button button button--primary" data-set-buy-add ${canAddInitially ? "" : "disabled"}>
                  ${availableVariants.length ? escapeHtml(strings.addToCart) : escapeHtml(strings.soldOut)}
                </button>
              </div>
            </div>
          </div>
        </div>
      `;

      this._selectedVariantId = initialVariant && initialVariant.available ? initialVariant.id : null;
      this._selectedOptions = selected.slice();
      this._optionsMeta = options;
      this._variants = variants;

      const addButton = body.querySelector("[data-set-buy-add]");
      const status = body.querySelector("[data-set-buy-status]");
      const priceEl = body.querySelector("[data-set-buy-price]");
      const imageEl = body.querySelector("[data-set-buy-image]");
      const optionSelects = Array.from(body.querySelectorAll("[data-set-buy-option]"));

      const syncFromSelection = () => {
        this._selectedOptions = optionSelects.map((select) => select.value);
        optionSelects.forEach((select) => {
          const wrap = select.closest(".select-wrapper");
          if (!wrap) return;
          const trigger = wrap.querySelector("[data-set-buy-option-trigger]");
          syncOptionTriggerLabel(trigger, select.value, select);
        });
        const variant = findVariant(variants, this._selectedOptions);
        this._selectedVariantId = variant && variant.available ? variant.id : null;
        if (addButton) {
          addButton.disabled = !this._selectedVariantId;
          if (!availableVariants.length) {
            addButton.disabled = true;
            addButton.textContent = strings.soldOut;
          } else if (!variant) {
            addButton.textContent = strings.unavailable;
          } else if (!variant.available) {
            addButton.textContent = strings.soldOut;
          } else {
            addButton.textContent = strings.addToCart;
          }
        }
        if (variant && priceEl) {
          priceEl.textContent = formatMoney(variant.price);
        }
        if (variant && variant.featured_image && imageEl) {
          const next = imageUrl(variant.featured_image, 120);
          if (next) imageEl.src = next;
        }
        if (status) {
          status.textContent = "";
          status.className = "set-buy-modal__status";
        }
      };

      optionSelects.forEach((select) => {
        select.addEventListener("change", syncFromSelection);
      });

      if (addButton) {
        if (!availableVariants.length) {
          addButton.disabled = true;
        }
        addButton.addEventListener("click", async () => {
          if (!this._selectedVariantId) return;
          addButton.disabled = true;
          addButton.setAttribute("aria-busy", "true");
          if (status) {
            status.textContent = "";
            status.className = "set-buy-modal__status";
          }
          const result = await addVariantToCart(this._selectedVariantId, 1);
          addButton.removeAttribute("aria-busy");
          if (result.ok) {
            if (status) {
              status.textContent = strings.added;
              status.className = "set-buy-modal__status is-success";
            }
            addButton.disabled = !this._selectedVariantId;
          } else {
            if (status) {
              status.textContent = (result.json && (result.json.description || result.json.message)) || strings.unavailable;
              status.className = "set-buy-modal__status is-error";
            }
            addButton.disabled = !this._selectedVariantId;
          }
        });
      }
    }
  };

  function railScrollerMarkup(listSelector = true) {
    return `
      <div class="set-buy-rail__viewport" data-set-buy-viewport>
        <div class="set-buy-rail__scroller scroller" data-set-buy-scroller>
          <div class="set-buy-rail__scroller-inner scroller__inner">
            <ul class="set-buy-rail__list" data-set-buy-list role="list"></ul>
          </div>
        </div>
      </div>
    `;
  }

  var SetBuyRail = class extends HTMLElement {
    async connectedCallback() {
      if (this._loaded) return;
      this._loaded = true;
      this._ensureScrollerStructure();
      /* Thin scrollbar is the scroll affordance; drop legacy hide-scrollbar. */
      this.querySelectorAll(".hide-scrollbar").forEach((el) => el.classList.remove("hide-scrollbar"));
      const productId = this.getAttribute("product-id");
      const limit = parseInt(this.getAttribute("recommendations-count") || "10", 10);
      if (!productId) {
        this.remove();
        return;
      }
      /*
        Match product-recommendations near-viewport defer (rootMargin 200px).
        Toast rails skip IO: host starts [hidden] (display:none → IO never fires)
        and toast pin already implies the user is looking at the mount.
        PDP/cart: pending skeleton keeps the host visible (CLS reserve) so IO
        can observe the rail itself; toast still observes after unhide path.
      */
      const context = this.getAttribute("context") || "";
      if (context !== "toast") {
        await this._untilNearby();
        if (!this.isConnected) {
          return;
        }
      }

      let intent = this.getAttribute("intent") || "complementary";
      const fallbackIntentAttr = this.getAttribute("fallback-intent") || "";
      const fallbackIntent = fallbackIntentAttr === "related" || fallbackIntentAttr === "complementary"
        ? fallbackIntentAttr
        : "";
      const isUnderAtcWithFallback = context === "pdp"
        && intent === "complementary"
        && fallbackIntent === "related"
        && !!this.closest(".product-form__under-atc-stack");

      /*
        Bottom おすすめ rail: if under-ATC complementary may fall back to related,
        wait for that decision so we do not flash a duplicate related rail.
      */
      if (context === "pdp" && intent === "related" && this._isBottomRelatedRail()) {
        const decision = await this._waitForUnderAtcFallbackDecision();
        if (!this.isConnected) return;
        if (decision && decision.usedRelatedFallback) {
          this._removeEmptyHosts();
          return;
        }
        if (document.documentElement.getAttribute("data-set-buy-related-under-atc") === "1") {
          this._removeEmptyHosts();
          return;
        }
      }

      let products = [];
      try {
        products = await fetchRecommendations(productId, limit, intent);
      } catch (_err) {
        products = [];
      }
      const excludeRaw = this.getAttribute("exclude-product-ids") || "";
      products = filterExcludedProducts(products, excludeRaw);

      let usedRelatedFallback = false;
      if (!products.length && isUnderAtcWithFallback) {
        try {
          products = await fetchRecommendations(productId, limit, "related");
        } catch (_err) {
          products = [];
        }
        products = filterExcludedProducts(products, excludeRaw);
        if (products.length) {
          usedRelatedFallback = true;
          intent = "related";
          this.setAttribute("intent", "related");
          this.setAttribute("data-fallback-from", "complementary");
        }
      }

      if (!products.length) {
        if (isUnderAtcWithFallback) {
          this._underAtcResolved = true;
          this._usedRelatedFallback = false;
          announceUnderAtcResolved(false);
        }
        this._removeEmptyHosts();
        return;
      }

      /*
        Under-ATC with fallback-intent: host starts [hidden] (defer-reveal).
        Paint the final heading once, then reveal — never flash 人気カスタム
        while related fallback is still pending / about to swap.
      */
      if (isUnderAtcWithFallback) {
        this._applyUnderAtcFinalHeading(usedRelatedFallback);
      }

      this._productsById = {};
      products.forEach((p) => {
        this._productsById[p.id] = p;
      });
      this._renderList(products);
      this._syncThumbSizeToGallery();
      this._clearPendingSkeleton();
      this.hidden = false;
      this.removeAttribute("hidden");
      this.classList.remove("set-buy-rail--defer-reveal");
      if (!this._railEventsBound) {
        this._railEventsBound = true;
        this._onRailClick = this._onRailClick.bind(this);
        this._onRailChange = this._onRailChange.bind(this);
        this.addEventListener("click", this._onRailClick);
        this.addEventListener("change", this._onRailChange);
      }
      /* PDP: keep preferred size/機種 in sync with the product form. */
      if (context === "pdp") {
        this._bindPdpVariantSync();
        const livePrefs = this._readLivePdpPreferredOptions();
        if (livePrefs.length) {
          this.setPreferredOptions(livePrefs);
        }
      }

      if (isUnderAtcWithFallback) {
        this._underAtcResolved = true;
        this._usedRelatedFallback = usedRelatedFallback;
        if (usedRelatedFallback) {
          hidePdpBottomRelatedRails();
        }
        announceUnderAtcResolved(usedRelatedFallback);
      }
    }
    /** Final under-ATC title before first paint (complementary or related). */
    _applyUnderAtcFinalHeading(usedRelatedFallback) {
      const strings = STRINGS();
      const title = usedRelatedFallback
        ? strings.relatedHeading
        : (this.getAttribute("heading") || strings.heading);
      this.setAttribute("heading", title);
      const headingEl = this.querySelector(".set-buy-rail__heading");
      if (headingEl) headingEl.textContent = title;
    }
    _isBottomRelatedRail() {
      return !!(
        this.closest('[data-product-related-rail="related"]')
        || this.closest(".product-content__featured-products--set-buy")
      );
    }
    _waitForUnderAtcFallbackDecision() {
      return new Promise((resolve) => {
        if (document.documentElement.getAttribute("data-set-buy-related-under-atc") === "1") {
          resolve({ usedRelatedFallback: true });
          return;
        }
        const underAtc = document.querySelector(
          '.product-form__under-atc-stack set-buy-rail[fallback-intent="related"]'
        );
        if (!underAtc) {
          resolve(null);
          return;
        }
        if (underAtc._underAtcResolved) {
          resolve({ usedRelatedFallback: !!underAtc._usedRelatedFallback });
          return;
        }
        if (!underAtc.isConnected) {
          resolve({
            usedRelatedFallback: document.documentElement.getAttribute("data-set-buy-related-under-atc") === "1"
          });
          return;
        }
        let settled = false;
        const finish = (detail) => {
          if (settled) return;
          settled = true;
          clearTimeout(timeoutId);
          document.documentElement.removeEventListener("set-buy:under-atc-resolved", onResolved);
          resolve(detail);
        };
        const onResolved = (event) => {
          finish(event.detail || { usedRelatedFallback: false });
        };
        const timeoutId = setTimeout(() => {
          finish({
            usedRelatedFallback: document.documentElement.getAttribute("data-set-buy-related-under-atc") === "1"
          });
        }, 8000);
        document.documentElement.addEventListener("set-buy:under-atc-resolved", onResolved);
      });
    }
    _removeEmptyHosts() {
      if (this.getAttribute("context") === "cart") {
        const row = this.closest("[data-cart-set-buy-row]");
        const container = this.closest("[data-cart-set-buy]");
        const section = this.closest(".shopify-section--cart-recommendations");
        this.remove();
        if (row) row.remove();
        /* Only tear down the cart section when no rails remain (multi-row safe). */
        if (container && !container.querySelector("set-buy-rail")) {
          (section || container).remove();
        }
        return;
      }
      /* Toast / PDP: drop empty rail; also clear PDP featured wrapper if empty. */
      const featured = this.closest(".product-content__featured-products--set-buy");
      const relatedWrap = this.closest('[data-product-related-rail="related"]');
      this.remove();
      if (featured && !featured.querySelector("set-buy-rail")) {
        featured.remove();
      }
      if (relatedWrap && !relatedWrap.querySelector("set-buy-rail")) {
        relatedWrap.remove();
      }
    }
    disconnectedCallback() {
      var _a;
      (_a = this._intersectionObserver) == null ? void 0 : _a.disconnect();
      if (this._onPdpVariantChanged) {
        document.removeEventListener("variant:changed", this._onPdpVariantChanged);
      }
    }
    _untilNearby() {
      return new Promise((resolve) => {
        if (!window.IntersectionObserver) {
          resolve();
          return;
        }
        /* Pending PDP/cart rails are visible; only pure [hidden] needs parent. */
        const target =
          this.hasAttribute("hidden") && !this.classList.contains("set-buy-rail--pending") && this.parentElement
            ? this.parentElement
            : this;
        this._intersectionObserver = new IntersectionObserver((entries) => {
          if (entries[0] && entries[0].isIntersecting) {
            this._intersectionObserver.disconnect();
            resolve();
          }
        }, { rootMargin: "200px 0px", threshold: 0 });
        this._intersectionObserver.observe(target);
      });
    }
    /** Drop CLS skeleton and show the real viewport after a successful fetch. */
    _clearPendingSkeleton() {
      this.classList.remove("set-buy-rail--pending");
      this.removeAttribute("aria-busy");
      this.style.minHeight = "";
      const skeleton = this.querySelector("[data-set-buy-skeleton]");
      if (skeleton) skeleton.remove();
      const viewport = this.querySelector("[data-set-buy-viewport]");
      if (viewport) {
        viewport.hidden = false;
        viewport.removeAttribute("hidden");
      }
    }
    /**
     * Align rail cells to the live PDP gallery .product__thumbnail outer box.
     * Primary sizing is CSS --product-thumbnail-size (theme.css breakpoints);
     * this covers zoom / unexpected layout drift (fractional widths included).
     * Peek is CSS viewport clip + peek-wider scroller — do not enlarge thumbs.
     */
    /** Cart + PDP rails use inline product cards; toast keeps thumbs → modal. */
    _usesInlineCards() {
      const context = this.getAttribute("context") || "";
      return context === "cart" || context === "pdp";
    }
    _syncThumbSizeToGallery() {
      /* Inline cards use fixed --set-buy-card-width; do not mirror gallery thumbs. */
      if (this._usesInlineCards()) return;
      const context = this.getAttribute("context") || "";
      if (context !== "pdp" && !this.classList.contains("set-buy-rail--pdp")) {
        return;
      }
      const galleryThumb = document.querySelector(
        "scroll-shadow.product__thumbnail-scroll-shadow:not(.product__media-extra-nav) .product__thumbnail, .product__media-nav .product__thumbnail"
      );
      if (!galleryThumb) return;
      const w = galleryThumb.getBoundingClientRect().width;
      if (!w || w < 24) return;
      const px = `${Math.round(w * 10) / 10}px`;
      this.style.setProperty("--set-buy-thumb-size", px);
      /* Keep gallery/set-buy on the same token if theme CSS var drifts. */
      this.style.setProperty("--product-thumbnail-size", px);
      if (!this._thumbSyncBound) {
        this._thumbSyncBound = true;
        window.addEventListener("resize", () => {
          window.requestAnimationFrame(() => this._syncThumbSizeToGallery());
        });
      }
    }
    _ensureViewport() {
      const scroller = this.querySelector("[data-set-buy-scroller]");
      if (!scroller) return;
      if (scroller.parentElement && scroller.parentElement.hasAttribute("data-set-buy-viewport")) {
        return;
      }
      const viewport = document.createElement("div");
      viewport.className = "set-buy-rail__viewport";
      viewport.setAttribute("data-set-buy-viewport", "");
      scroller.parentNode.insertBefore(viewport, scroller);
      viewport.appendChild(scroller);
    }
    _ensureScrollerStructure() {
      const heading = this.querySelector(".set-buy-rail__heading");
      const oldScroller = this.querySelector("[data-set-buy-scroller]");
      const list = this.querySelector("[data-set-buy-list]");
      if (oldScroller && list && !oldScroller.querySelector(".set-buy-rail__scroller-inner")) {
        const inner = document.createElement("div");
        inner.className = "set-buy-rail__scroller-inner scroller__inner";
        oldScroller.classList.add("scroller");
        oldScroller.classList.remove("hide-scrollbar");
        oldScroller.appendChild(inner);
        inner.appendChild(list);
      } else if (!oldScroller) {
        const wrap = document.createElement("div");
        wrap.innerHTML = railScrollerMarkup();
        const node = wrap.firstElementChild;
        if (heading && heading.nextSibling) {
          this.insertBefore(node, heading.nextSibling);
        } else {
          this.appendChild(node);
        }
      }
      this._ensureViewport();
    }
    _renderList(products) {
      const list = this.querySelector("[data-set-buy-list]");
      if (!list) return;
      if (this._usesInlineCards()) {
        this._renderInlineCards(products, list);
        return;
      }
      this.classList.remove("set-buy-rail--inline-cards");
      list.classList.remove("set-buy-rail__list--cards");
      list.innerHTML = products.map((product) => {
        const img = imageUrl(product, 240);
        const title = escapeHtml(product.title || "");
        const ariaLabel = title || STRINGS().heading;
        return `
          <li class="set-buy-rail__item">
            <button type="button" class="set-buy-rail__thumb" data-set-buy-product-id="${product.id}" aria-label="${ariaLabel}" aria-haspopup="dialog">
              ${img ? `<img class="set-buy-rail__image" src="${img}" alt="${title}" width="120" height="120" loading="lazy">` : `<span class="set-buy-rail__image" aria-hidden="true"></span>`}
            </button>
          </li>
        `;
      }).join("");
    }
    _renderInlineCards(products, list) {
      const strings = STRINGS();
      this.classList.add("set-buy-rail--inline-cards");
      list.classList.add("set-buy-rail__list--cards");
      list.innerHTML = products.map((product) => this._inlineCardMarkup(product, strings)).join("");
      list.querySelectorAll("[data-set-buy-card]").forEach((card) => {
        this._syncInlineCard(card);
      });
    }
    _cartPreferredOptions() {
      if (this._preferredOptionsCached) return this._preferredOptions;
      this._preferredOptionsCached = true;
      this._preferredOptions = parsePreferredOptions(this.getAttribute("preferred-options") || "");
      return this._preferredOptions;
    }
    /** Update preferred-options (cart line or PDP selected variant) and refresh cards. */
    setPreferredOptions(prefs) {
      const list = (Array.isArray(prefs) ? prefs : [])
        .map((item) => ({
          name: item && item.name != null ? String(item.name) : "",
          value: item && item.value != null ? String(item.value) : ""
        }))
        .filter((item) => item.value);
      this._preferredOptions = list;
      this._preferredOptionsCached = true;
      try {
        this.setAttribute("preferred-options", JSON.stringify(list));
      } catch (_err) {
        /* ignore attribute serialization errors */
      }
      this._applyPreferredSelectionToCards();
    }
    _sourceOptionNames() {
      const fromPrefs = (this._cartPreferredOptions() || []).map((p) => p.name).filter(Boolean);
      if (fromPrefs.length) return fromPrefs;
      const variantsEl = findProductVariantsEl(this.getAttribute("product-id"));
      return optionNamesFromProduct(variantsEl && variantsEl.product);
    }
    _readLivePdpPreferredOptions() {
      const productId = this.getAttribute("product-id");
      const variantsEl = findProductVariantsEl(productId);
      if (variantsEl && variantsEl.selectedVariant) {
        return preferredOptionsFromVariant(
          variantsEl.selectedVariant,
          optionNamesFromProduct(variantsEl.product)
        );
      }
      return parsePreferredOptions(this.getAttribute("preferred-options") || "");
    }
    _bindPdpVariantSync() {
      if (this._pdpVariantBound) return;
      this._pdpVariantBound = true;
      this._onPdpVariantChanged = this._onPdpVariantChanged.bind(this);
      document.addEventListener("variant:changed", this._onPdpVariantChanged);
    }
    _onPdpVariantChanged(event) {
      const variant = event && event.detail && event.detail.variant;
      if (!variant) return;
      const productId = this.getAttribute("product-id");
      if (variant.product_id != null && productId != null && String(variant.product_id) !== String(productId)) {
        return;
      }
      const form = event.target && event.target.tagName === "FORM"
        ? event.target
        : (event.target && event.target.closest ? event.target.closest("form") : null);
      let variantsEl = null;
      if (form && form.id) {
        try {
          variantsEl = document.querySelector(`product-variants[form-id="${CSS.escape(form.id)}"]`);
        } catch (_err) {
          variantsEl = document.querySelector(`product-variants[form-id="${form.id}"]`);
        }
      }
      if (!variantsEl) {
        variantsEl = findProductVariantsEl(productId);
      }
      if (variantsEl && variantsEl.product && productId != null
        && String(variantsEl.product.id) !== String(productId)) {
        return;
      }
      const names = optionNamesFromProduct(variantsEl && variantsEl.product);
      const prefs = preferredOptionsFromVariant(
        variant,
        names.length ? names : this._sourceOptionNames()
      );
      if (!prefs.length) return;
      this.setPreferredOptions(prefs);
    }
    /**
     * Re-apply preferred size/機種 to inline cards without resetting color
     * swatches the shopper already picked on each card.
     */
    _applyPreferredSelectionToCards() {
      if (!this._usesInlineCards() || !this._productsById) return;
      const prefs = this._cartPreferredOptions();
      if (!prefs.length) return;
      this.querySelectorAll("[data-set-buy-card]").forEach((card) => {
        const productId = card.getAttribute("data-set-buy-product-id");
        const product = this._productsById[productId];
        if (!product) return;
        const options = normalizeOptions(product);
        const preferred = cartInitialSelection(product, options, prefs);
        options.forEach((option, index) => {
          if (isColorOption(option.name)) return;
          const select = card.querySelector(`[data-set-buy-card-select][data-option-index="${index}"]`);
          if (!select) return;
          const next = preferred[index];
          if (next == null || next === "") return;
          const exists = Array.from(select.options).some((opt) => String(opt.value) === String(next));
          if (exists) select.value = next;
        });
        this._syncInlineCard(card);
      });
    }
    _inlineCardMarkup(product, strings) {
      const options = normalizeOptions(product);
      const variants = product.variants || [];
      const selected = cartInitialSelection(product, options, this._cartPreferredOptions());
      const initialVariant = findVariant(variants, selected)
        || variants.find((v) => v.available)
        || variants[0]
        || null;
      const img = imageUrl(initialVariant && initialVariant.featured_image ? initialVariant : product, 320);
      const title = escapeHtml(product.title || "");
      const href = productHref(product);
      const hrefAttr = href ? escapeHtml(href) : "";
      const price = formatMoney((initialVariant && initialVariant.price) || product.price);

      const colorOptionsHtml = options.map((option, index) => {
        if (!isColorOption(option.name)) return "";
        const current = selected[index] || option.values[0] || "";
        const radioName = `set-buy-${product.id}-opt-${index}`;
        /* Reuse product-item mini swatch classes (color-swatch-list--mini). */
        return `
          <div class="set-buy-card__swatches product-item-meta__swatch-list color-swatch-list color-swatch-list--mini" role="radiogroup" aria-label="${escapeHtml(option.name)}" data-set-buy-card-option-index="${index}">
            ${option.values.map((value, valueIndex) => {
              const checked = String(value) === String(current);
              const whiteClass = String(value).toLowerCase() === "white" ? " color-swatch--white" : "";
              const style = escapeHtml(resolveThemeSwatchStyle(value));
              const inputId = `set-buy-${product.id}-opt-${index}-${valueIndex}`;
              return `
                <div class="color-swatch${whiteClass}">
                  <input
                    class="color-swatch__radio visually-hidden"
                    type="radio"
                    name="${radioName}"
                    id="${inputId}"
                    value="${escapeHtml(value)}"
                    ${checked ? "checked" : ""}
                    data-set-buy-card-swatch
                    data-option-index="${index}"
                    data-option-value="${escapeHtml(value)}"
                  >
                  <label class="color-swatch__item" for="${inputId}" style="${style}">
                    <span class="visually-hidden">${escapeHtml(option.name)}: ${escapeHtml(value)}</span>
                  </label>
                </div>
              `;
            }).join("")}
          </div>
        `;
      }).join("");

      const dropdownOptionsHtml = options.map((option, index) => {
        if (isColorOption(option.name)) return "";
        const current = selected[index] || option.values[0] || "";
        const sizeHint = isSizeOption(option.name) ? " set-buy-card__select--size" : "";
        /* Hidden native select + trigger → sticky-ATC combo-box sheet (not iOS picker). */
        return `
          <div class="set-buy-card__select-wrap">
            <select class="set-buy-card__select visually-hidden${sizeHint}" data-set-buy-card-select data-option-index="${index}" aria-label="${escapeHtml(option.name)}" tabindex="-1">
              ${option.values.map((value) => {
                const selectedAttr = String(value) === String(current) ? " selected" : "";
                return `<option value="${escapeHtml(value)}"${selectedAttr}>${escapeHtml(value)}</option>`;
              }).join("")}
            </select>
            <button
              type="button"
              class="set-buy-card__select-trigger${sizeHint}"
              data-set-buy-option-trigger
              data-option-name="${escapeHtml(option.name)}"
              aria-expanded="false"
              aria-haspopup="listbox"
              aria-label="${escapeHtml(option.name)}: ${escapeHtml(current)}"
            >
              <span class="set-buy-card__select-trigger-label" data-set-buy-option-trigger-label>${escapeHtml(current)}</span>
              ${CHEVRON_SVG}
            </button>
          </div>
        `;
      }).join("");

      const media = img
        ? `<img class="set-buy-card__image" src="${img}" alt="${title}" width="160" height="160" loading="lazy" data-set-buy-card-image>`
        : `<span class="set-buy-card__image set-buy-card__image--empty" aria-hidden="true" data-set-buy-card-image></span>`;

      return `
        <li class="set-buy-rail__item set-buy-rail__item--card">
          <article class="set-buy-card" data-set-buy-card data-set-buy-product-id="${product.id}">
            ${hrefAttr
              ? `<a class="set-buy-card__media" href="${hrefAttr}">${media}</a>`
              : `<div class="set-buy-card__media">${media}</div>`}
            ${hrefAttr
              ? `<a class="set-buy-card__title" href="${hrefAttr}">${title}</a>`
              : `<span class="set-buy-card__title">${title}</span>`}
            ${colorOptionsHtml}
            ${dropdownOptionsHtml}
            <div class="set-buy-card__footer">
              <p class="set-buy-card__price" data-set-buy-card-price>${price}</p>
              <button type="button" class="set-buy-card__add" data-set-buy-card-add>
                ${escapeHtml(strings.addShort)}
              </button>
            </div>
            <p class="set-buy-card__status" data-set-buy-card-status role="status" aria-live="polite"></p>
          </article>
        </li>
      `;
    }
    _readCartCardSelection(card, product) {
      const options = normalizeOptions(product);
      const selected = options.map((option, index) => {
        if (isColorOption(option.name)) {
          const active = card.querySelector(`[data-set-buy-card-swatch][data-option-index="${index}"]:checked`);
          return (active && (active.value || active.getAttribute("data-option-value"))) || option.values[0] || "";
        }
        const select = card.querySelector(`[data-set-buy-card-select][data-option-index="${index}"]`);
        return (select && select.value) || option.values[0] || "";
      });
      return { options, selected };
    }
    _syncInlineCard(card) {
      const productId = card.getAttribute("data-set-buy-product-id");
      const product = this._productsById[productId];
      if (!product) return;
      const strings = STRINGS();
      const variants = product.variants || [];
      const { options, selected } = this._readCartCardSelection(card, product);

      /* Nudge unavailable picks toward a valid combo before painting controls. */
      options.forEach((option, index) => {
        if (isOptionValueAvailable(variants, index, selected[index], selected)) return;
        const fallback = option.values.find((value) => isOptionValueAvailable(variants, index, value, selected));
        if (fallback) selected[index] = fallback;
      });

      options.forEach((option, index) => {
        if (isColorOption(option.name)) {
          card.querySelectorAll(`[data-set-buy-card-swatch][data-option-index="${index}"]`).forEach((swatch) => {
            const value = swatch.getAttribute("data-option-value") || swatch.value;
            const available = isOptionValueAvailable(variants, index, value, selected);
            const isSelected = String(value) === String(selected[index]);
            swatch.disabled = !available;
            swatch.checked = isSelected;
            const wrap = swatch.closest(".color-swatch");
            if (wrap) wrap.classList.toggle("is-disabled", !available);
          });
        } else {
          const select = card.querySelector(`[data-set-buy-card-select][data-option-index="${index}"]`);
          if (!select) return;
          Array.from(select.options).forEach((optEl) => {
            optEl.disabled = !isOptionValueAvailable(variants, index, optEl.value, selected);
          });
          select.value = selected[index];
          const trigger = select.closest(".set-buy-card__select-wrap")
            && select.closest(".set-buy-card__select-wrap").querySelector("[data-set-buy-option-trigger]");
          syncOptionTriggerLabel(trigger, selected[index], select);
          if (trigger) trigger.disabled = select.disabled;
        }
      });

      const resolved = options.length
        ? findVariant(variants, selected)
        : (variants.find((v) => v.available) || variants[0] || null);

      const priceEl = card.querySelector("[data-set-buy-card-price]");
      const imageEl = card.querySelector("[data-set-buy-card-image]");
      const addButton = card.querySelector("[data-set-buy-card-add]");
      const status = card.querySelector("[data-set-buy-card-status]");
      const canAdd = Boolean(resolved && resolved.available);

      if (priceEl && resolved) {
        priceEl.textContent = formatMoney(resolved.price);
      }
      if (imageEl && imageEl.tagName === "IMG") {
        const source = resolved && resolved.featured_image ? resolved.featured_image : product;
        const next = imageUrl(source, 320);
        if (next) imageEl.src = next;
      }
      if (addButton) {
        addButton.disabled = !canAdd;
        if (!(variants || []).some((v) => v.available)) {
          addButton.textContent = strings.soldOut;
        } else if (!resolved) {
          addButton.textContent = strings.unavailable;
        } else if (!resolved.available) {
          addButton.textContent = strings.soldOut;
        } else {
          addButton.textContent = strings.addShort;
        }
      }
      if (status) {
        status.textContent = "";
        status.className = "set-buy-card__status";
      }
      card._selectedVariantId = canAdd ? resolved.id : null;
    }
    _onRailClick(event) {
      if (this._usesInlineCards()) {
        this._onInlineCardClick(event);
        return;
      }
      this._onThumbClick(event);
    }
    _onRailChange(event) {
      if (!this._usesInlineCards()) return;
      const control = event.target.closest("[data-set-buy-card-select], [data-set-buy-card-swatch]");
      if (!control) return;
      const card = control.closest("[data-set-buy-card]");
      if (card) this._syncInlineCard(card);
    }
    _onInlineCardClick(event) {
      const trigger = event.target.closest("[data-set-buy-option-trigger]");
      if (trigger && this.contains(trigger)) {
        event.preventDefault();
        openOptionSheetFromTrigger(trigger);
        return;
      }
      const addButton = event.target.closest("[data-set-buy-card-add]");
      const card = event.target.closest("[data-set-buy-card]");
      if (!card || !addButton) return;
      event.preventDefault();
      this._addInlineCard(card, addButton);
    }
    async _addInlineCard(card, addButton) {
      if (!card._selectedVariantId || addButton.disabled) return;
      const strings = STRINGS();
      const status = card.querySelector("[data-set-buy-card-status]");
      addButton.disabled = true;
      addButton.setAttribute("aria-busy", "true");
      if (status) {
        status.textContent = "";
        status.className = "set-buy-card__status";
      }
      /* Cart page: refresh main + recommendations, no toast; PDP: toast OK. */
      const cartSections = collectCartPageSectionIds();
      const isCartContext = (this.getAttribute("context") || "") === "cart";
      const result = await addVariantToCart(card._selectedVariantId, 1, {
        sections: cartSections,
        refreshCartPage: cartSections.length > 0,
        suppressNotification: isCartContext
      });
      addButton.removeAttribute("aria-busy");
      /* Cart page section replace remounts rails; only sync if this card survived. */
      if (this.isConnected && card.isConnected) {
        this._syncInlineCard(card);
      }
      if (result.ok) {
        if (status && status.isConnected) {
          status.textContent = strings.added;
          status.className = "set-buy-card__status is-success";
        }
      } else if (status && status.isConnected) {
        status.textContent = (result.json && (result.json.description || result.json.message)) || strings.unavailable;
        status.className = "set-buy-card__status is-error";
      }
    }
    _onThumbClick(event) {
      const button = event.target.closest("[data-set-buy-product-id]");
      if (!button || button.closest("[data-set-buy-card]")) return;
      const id = button.getAttribute("data-set-buy-product-id");
      const product = this._productsById[id];
      const modal = getModal();
      if (product && modal && typeof modal.open === "function") {
        modal.open(product);
      }
    }
  };

  if (!customElements.get("set-buy-modal")) {
    customElements.define("set-buy-modal", SetBuyModal);
  }
  if (!customElements.get("set-buy-rail")) {
    customElements.define("set-buy-rail", SetBuyRail);
  }

  window.CiaraSetBuy = {
    fetchComplementary,
    fetchRecommendations,
    mountRail(container, productId, options = {}) {
      if (!container || !productId) return null;
      const intent = options.intent === "related" ? "related" : "complementary";
      const strings = STRINGS();
      const heading = options.heading || (intent === "related" ? strings.relatedHeading : strings.heading);
      const limit = options.limit || 10;
      const context = options.context || "toast";
      if (options.append) {
        /* Toast dual-row: replace same-intent only; keep the sibling row. */
        const existing = container.querySelector(`set-buy-rail[intent="${intent}"]`);
        if (existing) existing.remove();
      } else {
        container.querySelectorAll("set-buy-rail").forEach((el) => el.remove());
      }
      const rail = document.createElement("set-buy-rail");
      rail.className = `set-buy-rail set-buy-rail--${context}`;
      rail.setAttribute("product-id", String(productId));
      rail.setAttribute("recommendations-count", String(limit));
      rail.setAttribute("heading", heading);
      rail.setAttribute("context", context);
      rail.setAttribute("intent", intent);
      rail.hidden = true;
      rail.innerHTML = `
        <h2 class="js-summary set-buy-rail__heading">${escapeHtml(heading)}</h2>
        ${railScrollerMarkup()}
      `;
      container.appendChild(rail);
      return rail;
    },
    /**
     * Pinned CartNotification under-toast: complementary then related.
     * Each rail self-removes when empty so vacant rows stay hidden.
     */
    mountToastRails(container, productId, options = {}) {
      if (!container || !productId) return [];
      container.innerHTML = "";
      const strings = STRINGS();
      const limit = options.limit || 10;
      const complementary = this.mountRail(container, productId, {
        context: "toast",
        intent: "complementary",
        heading: options.complementaryHeading || strings.heading,
        limit,
        append: true
      });
      const related = this.mountRail(container, productId, {
        context: "toast",
        intent: "related",
        heading: options.relatedHeading || strings.relatedHeading,
        limit,
        append: true
      });
      return [complementary, related].filter(Boolean);
    }
  };
})();
